__webpack_require__.p = "https://teststatic.wetvinfo.com/wetvlinux/";